var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, headerAttributes, id, title, validationId) {
      


































pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}
pug_mixins["fieldset"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
fieldsetCounter++;
title = attributes.title || ''
delete attributes.title
headerAttributes = {}
if (!attributes.noCollapse) {
headerAttributes['ng-click'] = 'fieldset'+ fieldsetCounter +'.closed = !fieldset'+ fieldsetCounter +'.closed'
}
if (attributes.closed) {
headerAttributes['ng-init'] = 'fieldset'+ fieldsetCounter +'.closed =' + attributes.closed
delete attributes.closed
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "bigbox"},attributes]), true)) + "\u003E\u003Cdiv" + (pug.attrs(pug.merge([{"class": "header"},headerAttributes]), true)) + "\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
if (!attributes.noCollapse) {
pug_html = pug_html + "\u003Cspan" + (" class=\"openable\""+pug.attr("ng-class", '{selected: !fieldset'+ fieldsetCounter +'.closed}', true, true)) + "\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"main\""+pug.attr("ng-hide", 'fieldset'+ fieldsetCounter +'.closed', true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"cockpit_arbeitnmv-wrapper\" overlay=\"$ctrl.loading.search || $ctrl.loading.main\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["fieldset"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.filters.employeeId","title": "Arbeitnehmer ID","data-cy": "vn.administration.carLeasing.filters.inputEmployeeId","type": "number"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.filters.customerId","title": "Kundennummer","data-cy": "vn.administration.carLeasing.filters.inputCustomerId","type": "number"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.filters.finnOrderId","title": "FINN Deal Id","data-cy": "vn.administration.carLeasing.filters.inputFinnOrderId"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cdatepicker class=\"date\" date-format=\"dd.MM.yyyy\" selector=\"entrydateInput\" date-refocus=\"true\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.filters.preferredDeliveryDate","title": "Gewünschtes Lieferdatum","attributes": {"vn-date":"true","vn-date-reformat":"true","vn-date-string-model":"true","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F"},"data-cy": "vn.administration.carLeasing.filters.preferredDeliveryDate","fieldHtmlClass": "entrydateInput"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EAuftragsstatus\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"$ctrl.filters.orderStates.selected\" theme=\"select2\" title=\"'Order states filter\" search-enabled=\"false\" close-on-select=\"false\" style=\"width:100%\" data-cy=\"vn.administration.carLeasing.filters.orderStates\" multiple\u003E\u003Cui-select-match placeholder=\"Select Order State...\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"state.id as state in $ctrl.filters.orderStates.options\"\u003E\u003Cspan ng-bind=\"state.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E\u003Cbutton class=\"button button-primary\" data-cy=\"vn.administration.carLeasing.employeeFilters.buttonSearch\" ng-click=\"$ctrl.search();\"\u003ESuchen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "overflow-show","title": "{{ $ctrl.results }} Warenkörbe gefunden. Bitte mindestens einen Filter angeben"}
});
pug_html = pug_html + "\u003Cdiv ng-repeat=\"basket in $ctrl.carBaskets\" overlay=\"$ctrl.loading.search || $ctrl.loading.main\"\u003E\u003Cdiv class=\"mpp_basket_list_container\"\u003E\u003Cdiv class=\"list-box__row bigbox\" ng-class=\"{'toggable-content-open': basket.toggleContentShowable }\" toggable-content=\"basket.toggleContentShowable\" data-cy=\"vn.administration.carLeasing.{{basket.employeeId}}-{{basket.id}}.toggleBasket\"\u003E\u003Ctoggable-content-toggler ng-init=\"basket.toggleContentShowable\" ng-click=\"$ctrl.load(basket)\"\u003E\u003Cdiv class=\"list-box__item\"\u003E\u003Cspan class=\"list-box__itemTitle\" ng-click=\"togglerClicked()\"\u003E\u003Cdiv class=\"header\" ng-style=\"(!basket.orderId &amp;&amp; !basket.isCancelled) &amp;&amp; {&quot;background-color&quot;:&quot;yellow&quot;}\"\u003E\u003Cspan\u003E{{ basket.employeeId }}, {{ basket.employee.firstname }} {{ basket.employee.lastname }}\u003C\u002Fspan\u003E\u003Cspan class=\"right\" ng-if=\"basket.isCancelled\" style=\"margin-left: 20px; color: red; text-decoration:underline\"\u003EAbgelehnt\u003C\u002Fspan\u003E\u003Cbutton class=\"button button-primary isOutline right\" ng-if=\"$ctrl.canOpenTicketDialog(basket) &amp;&amp; !basket.isCancelled\" ng-click=\"$ctrl.openTicketDialog(basket, $event)\" data-cy=\"vn.administration.carLeasing.{{basket.employeeId}}-{{basket.id}}.buttonOrderProcess\"\u003ETicket Creation\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline right\" ng-if=\"!basket.orderId &amp;&amp; !basket.isCancelled\" ng-disabled=\"$ctrl.loading.finnRequest\" ng-click=\"$ctrl.triggerFinnRequest(basket, $event)\" data-cy=\"vn.administration.carLeasing.{{basket.employeeId}}-{{basket.id}}.buttonFinnRequest\"\u003ESend Finn Request\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary isOutline right\" ng-if=\"basket.isAwaitingFirstCheckApproval() &amp;&amp; !basket.isCancelled\" ng-click=\"$ctrl.openFirstCheckDialog(basket, $event)\" data-cy=\"vn.administration.carLeasing.{{basket.employeeId}}-{{basket.id}}.buttonFirstCheck\"\u003EFirst Check\u003C\u002Fbutton\u003E\u003Cspan class=\"right\" ng-if=\"basket.isWaitingForFirstCheckUpload()\" style=\"margin-left: 20px; color: #966904; text-decoration:underline\"\u003EFirst Check State: BO Requested New Files\u003C\u002Fspan\u003E\u003Cspan class=\"right\" ng-if=\"basket.isFirstCheckApproved()\" style=\"margin-left: 20px; color: green; text-decoration:underline\" data-cy=\"vn.administration.carLeasing.{{basket.employeeId}}-{{basket.id}}.textFirstCheckState\"\u003EFirst Check State: Approved\u003C\u002Fspan\u003E\u003Cspan class=\"right\" ng-if=\"basket.isFirstCheckRejected()\" style=\"margin-left: 20px; color: red; text-decoration:underline\"\u003EFirst Check State: Rejected\u003C\u002Fspan\u003E\u003Cbutton class=\"button button-primary isOutline right\" ng-if=\"basket.isAwaitingContractProcessApproval()\" ng-click=\"$ctrl.openContractProcessDialog(basket, $event)\" data-cy=\"vn.administration.carLeasing.{{basket.employeeId}}-{{basket.id}}.buttonControlProcess\"\u003EContract Process\u003C\u002Fbutton\u003E\u003Cspan class=\"right\" ng-if=\"basket.isReadyToSign\" style=\"margin-left: 20px; color: blue; text-decoration:underline\"\u003EWaiting Employee To Sign And Upload Contract\u003C\u002Fspan\u003E\u003Cspan class=\"right\" ng-if=\"basket.isContractProcessApproved()\" style=\"margin-left: 20px; color: green; text-decoration:underline\" data-cy=\"vn.administration.carLeasing.{{basket.employeeId}}-{{basket.id}}.textControlProcessState\"\u003EContract Process State: Approved\u003C\u002Fspan\u003E\u003Cspan class=\"right\" ng-if=\"basket.isWaitingForNewContractUpload()\" style=\"margin-left: 20px; color: #966904; text-decoration:underline\"\u003EContract Process State: BO Requested New Contract\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"list-box__item__content\" toggable-content-content ng-if=\"basket.toggleContentShowable\"\u003E\u003Cdiv class=\"cockpit_toggable-content\"\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"row\" ng-if=\"basket\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"vn-table\"\u003E\u003Ctable\u003E\u003Ctbody\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EBasket Id:\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.id }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EValueNet ID\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.employeeId }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003ETelefonnummer Mitarbeiter\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.deliveryPhone }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003ECustomer\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.customerId }}, {{ basket.customer.name }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EFINN Deal Id:\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cdiv\u003E\u003Cspan ng-if=\"basket.orderId\"\u003E{{ basket.orderId }}\u003C\u002Fspan\u003E\u003Ca ng-if=\"!basket.orderId\" ng-click=\"$ctrl.openAddFinnDataDialog(basket, $event)\"\u003EAuftragsnummer hinzufügen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EOTRS Ticket:\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca ng-if=\"basket.otrs\" href=\"{{ basket.otrs.ticketUrl }}\" target=\"_blank\"\u003E{{ basket.otrs.ticketNumber }}\u003C\u002Fa\u003E\u003Cspan ng-if=\"!basket.otrs\"\u003E-\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003ECheckout Datum\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.checkoutDate }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EFreigabestatus Arbeitgeber\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.approvalState }}\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EGewünschtes Lieferdatum\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan ng-if=\"basket.preferredDeliveryDate\"\u003E{{ basket.preferredDeliveryDate * 1000 | date }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!basket.preferredDeliveryDate\"\u003E-\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003EFahrzeugdaten\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca href=\"https:\u002F\u002Fwww.finn.auto\u002Fpdp\u002F{{ basket.checkoutConfiguration.car_id }}\" target=\"_blank\"\u003E{{ basket.checkoutConfiguration.car_brand }} {{ basket.checkoutConfiguration.car_model }}\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan\u003ELeistung Fahrzeug\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan\u003E{{ basket.checkoutConfiguration.power }} kW\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003EFührerschein\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cdiv class=\"hide-overflow\" ng-repeat=\"(slot, df) in basket.firstCheckFiles.drivingLicenseFiles\"\u003E\u003Ca ng-click=\"$ctrl.openFile(df)\"\u003E{{ (slot == \"selfie\" ?\"Hologramm\" : (slot == \"back\" ?\"Zahlen\" : (slot == \"front\" ?\"Vorderseite\" : slot))) }}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-repeat=\"contractItem in basket.contractSigningProcess\"\u003E\u003Ctd\u003EUnterlagen ({{ contractItem.process_type }})\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cdiv ng-if=\"contractItem.file_id\"\u003E\u003Ca ng-click=\"$ctrl.openFile(contractItem.file_id)\"\u003EOpen Contract\u003C\u002Fa\u003E\u003Ca ng-if=\"$ctrl.auditTrails[basket.id]['file'][$index]\"\u003E\u003Cspan\u003E&nbsp; | &nbsp;\u003C\u002Fspan\u003E\u003Ci class=\"font-icon font-icon-alt icon-document\" ng-click=\"$ctrl.openFile($ctrl.auditTrails[basket.id]['file'][$index]._id)\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!contractItem.file_id\"\u003E\u003Cspan\u003E-\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"basket\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cbutton class=\"button button-secondary alert\" ng-disabled=\"!$ctrl.canOpenCancellationDialog(basket)\" ng-click=\"$ctrl.openCancellationDialog(basket, $event)\" data-cy=\"vn.administration.carLeasing.{{basket.employeeId}}-{{basket.id}}.buttonCancelBasket\"\u003EStornieren\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.goToNEO(basket.employeeId)\"\u003ENEO\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftoggable-content-toggler\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","id": "carleasingFilters"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "headerAttributes" in locals_for_with ?
        locals_for_with.headerAttributes :
        typeof headerAttributes !== 'undefined' ? headerAttributes : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;